// extracted by mini-css-extract-plugin
export var socialItem = "social-medias-module--social-item--83517";
export var socialLinks = "social-medias-module--social-links--98c6e";